import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestModel } from 'src/app/typings/typing';

@Injectable({
  providedIn: 'root'
})
export class RoleManagementService {

  prefix = '/role';

  constructor(private http: HttpClient) { }

  getTableList(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryPage', params);
  }

  addOrUpdate(row: any) {
    if (row.id) {
      return this.http.put<RequestModel>(this.prefix + '/update', row);
    } else {
      return this.http.post<RequestModel>(this.prefix + '/save', row);
    }
  }

  delete(id: number | string) {
    return this.http.delete<RequestModel>(this.prefix + `/delete/${id}`, {});
  }

  addPermissionToRole(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/mappingPermissions', params);
  }
}
